console.log('test');
$(".spinner-down").on("click", function () {
    let current_qty = parseInt($(this).nextAll("input").val());
    let change_qty = current_qty - 1;
    $(this).nextAll("input").attr("value", change_qty);
    $(this).nextAll("input").attr("data-cart-quantity", change_qty);
    var item_index = $(this).attr("item_index");
    lineitemQuantity(item_index, change_qty);
});


//数量スピナーボタン（プラス）
$(".spinner-up").on("click", function () {
    let current_qty = parseInt($(this).prevAll("input").val());
    let change_qty = current_qty + 1;
    $(this).prevAll("input").attr("value", change_qty);
    $(this).nextAll("input").attr("data-cart-quantity", change_qty);
    var item_index = $(this).attr("item_index");
    lineitemQuantity(item_index, change_qty);
});

function lineitemQuantity(line, quantity) {
    var quantity = quantity;
    fetch("/cart/change", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            line: line,
            quantity: quantity,
        }),
    }).then(() => {
        location.reload();
    });
}

this.$el.on("click.cart-page", "[btnspinner]", this._editItemQuantity);
